import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "sonner";
import "@/App.css";

import { AuthProvider } from "@/context/AuthContext";
import { CartProvider } from "@/context/CartContext";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import MobileNav from "@/components/MobileNav";
import Seo from "@/components/Seo";

import Home from "@/pages/Home";
import Shop from "@/pages/Shop";
import ProductDetail from "@/pages/ProductDetail";
import Cart from "@/pages/Cart";
import Checkout from "@/pages/Checkout";
import OrderTracking from "@/pages/OrderTracking";
import TrackOrder from "@/pages/TrackOrder";
import ServiceRequest from "@/pages/ServiceRequest";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import VerifyEmail from "@/pages/VerifyEmail";
import Account from "@/pages/Account";
import Wishlist from "@/pages/Wishlist";
import AdminRedirect from "@/pages/AdminRedirect";
import Services from "@/pages/Services";
import Policy from "@/pages/Policy";
import Blogs from "@/pages/Blogs";
import BlogDetail from "@/pages/BlogDetail";

function App() {
  return (
    <div className="App">
      <HelmetProvider>
        <BrowserRouter>
          <AuthProvider>
            <CartProvider>
              <Seo />
              <Header />
              <main className="pb-20 md:pb-0">
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/shop" element={<Shop />} />
                  <Route path="/shop/:category" element={<Shop />} />
                  <Route path="/product/:id" element={<ProductDetail />} />
                  <Route path="/cart" element={<Cart />} />
                  <Route path="/checkout" element={<Checkout />} />
                  <Route path="/order/:orderId" element={<OrderTracking />} />
                  <Route path="/track" element={<TrackOrder />} />
                  <Route path="/site-visit" element={<ServiceRequest />} />
                  <Route path="/bulk" element={<Navigate to="/site-visit?type=bulk-plant-purchase-visit" replace />} />
                  <Route path="/services" element={<Services />} />
                  <Route path="/login" element={<Login />} />
                  <Route path="/register" element={<Register />} />
                  <Route path="/verify-email" element={<VerifyEmail />} />
                  <Route path="/account" element={<Account />} />
                  <Route path="/wishlist" element={<Wishlist />} />
                  <Route path="/admin" element={<AdminRedirect />} />
                  <Route path="/policies/:slug" element={<Policy />} />
                  <Route path="/blogs" element={<Blogs />} />
                  <Route path="/blogs/:url" element={<BlogDetail />} />
                  <Route path="*" element={<Home />} />
                </Routes>
              </main>
              <Footer />
              <MobileNav />
              <Toaster position="top-center" richColors />
            </CartProvider>
          </AuthProvider>
        </BrowserRouter>
      </HelmetProvider>
    </div>
  );
}

export default App;
